import styled from 'styled-components';

export const InfoHeaderStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 8rem;
`;

export const HeaderBlockStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 3rem;
`;
